import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cms/hero/Lucas-340.webp")